import React from 'react';
import * as Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, } from "@fortawesome/free-solid-svg-icons";
import { FloatingButton } from './';
const FloatingUpButton = React.memo((props) => {
    const scroll = Scroll.animateScroll;
    const handleOnClick = () => {
        scroll.scrollToTop({ duration: 300 });
    };
    const icon = props.icon ? props.icon : React.createElement(FontAwesomeIcon, { icon: faArrowUp, className: `text-xl` });
    return (React.createElement(FloatingButton, { mainButtonStyles: {
            width: '2.5rem',
            height: '2.5rem',
            opacity: 0.7,
        }, icon: icon, onClick: handleOnClick }));
});
export default FloatingUpButton;
